import {createContext, useContext} from 'react';

import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {BenchlingNodeV2Status} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeV2Constants';

export interface BenchlingNodeV2SectionInfo {
  name: string;
  icon: BenchlingIconName;
  count: number;
}

export interface BenchlingNodeV2ContextValue {
  status?: BenchlingNodeV2Status;
  statusDescription?: string | JSX.Element;
  isDisabled: boolean;
}

const DEFAULT_BENCHLING_NODE_V2_CONTEXT_VALUE: BenchlingNodeV2ContextValue = {
  isDisabled: false,
};

/* @package */
export const BenchlingNodeV2Context = createContext(DEFAULT_BENCHLING_NODE_V2_CONTEXT_VALUE);

/* @package */
export const useBenchlingNodeV2Context: () => BenchlingNodeV2ContextValue = () =>
  useContext(BenchlingNodeV2Context);
